jQuery(document).ready(function( $ ) {

    const navExpand = [].slice.call(document.querySelectorAll('.nav-expand'));

    $(".nav-link").click(function(){
        
        $(this).closest(".nav-item.nav-expand").addClass("active");
    });

    $(".nav-back-link").click(function(){
        $(this).closest(".nav-item.nav-expand").removeClass("active");
    });

    // ---------------------------------------
    // not-so-important stuff starts here

    const ham = document.getElementById('ham');
    const hamclose = document.getElementById('ham-close');
    ham.addEventListener('click', function () {
    document.body.classList.toggle('nav-is-toggled');
    });

    hamclose.addEventListener('click', function () {
    document.body.classList.toggle('nav-is-toggled');
    });

    setInterval(function(){

        var max_height      = 0;
        var active_submenu  = $(".menu .parent-menu .sub-menu.active-item div:first");

        $.each($(".menu .parent-menu .sub-menu div:first"), function(index, el){
            if($(el).outerHeight() > max_height){
                max_height  = $(el).outerHeight();
            }
        });

        

        if($(active_submenu).length != 0){
            $(".menu").css('min-height', (max_height + 20) + 'px');
        }

        /*

        */

    }, 500);

});

